import { Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import UserModal from "../../components/common/modals/user-modal/UserModal";
import { useRef, useState } from "react";
import CurrencyInput from "../../components/common/inputs/CurrencyInput";
import { depositValidation } from "../../utils/validations/depositValidation";

export default function Deposit() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);

  const formHandler = async (values, { resetForm }) => {
    if (!values.transactionType) {
      return warningMessage("لطفا نوع تراکنش را انتخاب کنید.");
    }
    if (!user?._id) {
      return warningMessage("لطفا یک کاربر انتخاب کنید.");
    }

    const body = {
      ...values,
      user: user._id,
      isCommission: values.isCommission == "true" ? true : false,
      amount: Number(values.amount),
    };

    try {
      const path =
        values.transactionType === "deposit"
          ? "admin/wallets/deposit"
          : "admin/wallets/withdraw";
      await postApi({
        path,
        body: JSON.stringify(body),
      });
      successMessage("تراکنش با موفقیت انجام شد");
      resetForm();
      navigate("/wallets-transaction");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);

  const userModalRef = useRef();
  const amountRef = useRef();

  const handleUser = (data) => {
    setUser(data);
    setUserName(data?.name);
    successMessage(`کاربر ${data?.name} انتخاب شد`);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <Title title={"افزودن تراکنش"} />
      <Formik
        enableReinitialize
        initialValues={{
          amount: "",
          isCommission: "true",
          description: "",
        }}
        validationSchema={depositValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <div className="relative">
                  <Select
                    name="transactionType"
                    placeholder="نوع تراکنش"
                    label="نوع تراکنش"
                  >
                    <option>انتخاب تراکنش</option>
                    <option value={"deposit"}>واریز</option>
                    <option value={"withdrawal"}>برداشت</option>
                  </Select>
                  <span
                    onClick={() => userModalRef?.current?.showModal()}
                    className="absolute w-full h-full"
                  ></span>
                  <label className="block mb-4 mt-4 text-sm font-medium text-gray-900 dark:text-white">
                    انتخاب کاربر
                  </label>
                  <input
                    value={userName}
                    disabled
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                </div>
                <div>
                  <label
                    for="large-input"
                    className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    مبلغ
                  </label>
                  <CurrencyInput
                    placeholder="مبلغ"
                    ref={amountRef}
                    name="amount"
                    inputValue={formik.values["amount"]}
                    onChange={(e) => formik.setFieldValue("amount", e)}
                  />
                  {formik.errors.amount && formik.touched.amount ? (
                    <p className="text-sm my-4 text-red-500">
                      {formik.errors.amount}
                    </p>
                  ) : null}
                </div>

                <Select
                  name="isCommission"
                  placeholder="کمیسیونه ؟"
                  label="کمیسیونه ؟"
                >
                  <option value={"true"}>بله</option>
                  <option value={"false"}>خیر</option>
                </Select>

                <Input
                  name={"description"}
                  placeholder={"توضیحات"}
                  label={"توضیحات"}
                  type="text"
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <div className="flex items-center gap-2 mt-6">
                  <Button
                    text={location?.state ? "ویرایش" : "افزون"}
                    color={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
